import { useState, useEffect, useRef } from 'react';
import {checkEmail} from "Services/utils";
import EVENTS_API from "Services/EventAPI";
import LetterGif from 'assets/images/mail-animation.gif';
import { useTranslation } from "react-i18next";

function PopupFreeCode(props) {
    const { t,i18n } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState({name: {value: "", err: ""}, email: {value:"", err: ""}});
    const popupRef = useRef(null);

    const togglePopup = () => {
        setResponse(null);
        setData({name: {value: "", err: ""}, email: {value:"", err: ""}});
        setIsOpen(!isOpen);
    };

    useEffect(() => {
        const handleOutsideClick = (e) => {
            e.stopPropagation();
            if (e.target.getAttribute('name') === 'popupFreeCodeOverlay' && isOpen) {
                props.popupBtnRef?.current?.setAttribute('data-event', "");
                togglePopup();
            }
        };

        document.addEventListener('mousedown', handleOutsideClick);

        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, [isOpen]);

    const handleChanegData = (e) => {
        const {name, value,} = e.currentTarget;
        setData({...data, [name]: {...data[name], value:value}});
    }

    const handleSendFreeCode = () => {
        setIsLoading(true);
        let err = {name: '', email: ''};
        if (!checkEmail(data.email.value)) {
            err.email = 'book.form.email.err.invalid';
        }
        const name = data.name.value?.trim();
        if (name === '') {
            err.name = 'book.form.name.err.empty';
        }

        if (err.email || err.name) {
            setData({
                ...data,
                name: {...data.name, err: err.name},
                email: {...data.email, err: err.email},
            });
            setIsLoading(false);
            return;
        }

        setData({
            ...data,
            name: {...data.name, err: null},
            email: {...data.email, err: null},
        });

        EVENTS_API.freeCode({
            language: i18n.language,
            event_id: parseInt(props.popupBtnRef?.current?.getAttribute('data-event')),
            name: data.name?.value,
            email: data.email?.value,
            isFree: true
        })
            .then((res)=>{
                setData({name: {value: "", err: ""}, email: {value:"", err: ""}});
                setResponse({title: "freeCode.ok", message: "freeCode.ok.txt", reserved: true});
                props.popupBtnRef?.current?.setAttribute('data-event', "");
            }).catch((err)=>{
                if (err?.response) {
                    const {msg} = err?.response?.data;
                    if (msg === 'Event Not Found') {
                        console.log('Event Not Found');
                        setData({
                            ...data,
                            name: {...data.name, err: 'Event Not Found'},
                        });
                    }else if (msg === 'Email is already used') {
                        setData({
                            ...data,
                            email: {...data.email, err: t('requestCode.free.err.email')},
                        });
                       console.log('Email is already used');
                    }
                }else{
                    setResponse({title: "freeCode.err.unkown", message: "freeCode.err.unkown.txt", reserved: false});
                }
                console.log('response: ', err.response);
                console.log('err: ', err);
            }).finally(() =>{
                setIsLoading(false);
            })
    }

    const [response, setResponse] = useState(null);

    return (
        <div>
            {/* Button to toggle the popup */}
            <button style={{display: "none"}} data-event="" className='wb-button-blue' ref={props.popupBtnRef} onClick={togglePopup} disabled={props.disabled} title={t(props.data?.btnOpen?.tt)}>{t(props.data?.btnOpen?.txt)}</button>

            {/* Popup content */}
            {isOpen && (
                <div name="popupFreeCodeOverlay" className="wb-popup" ref={popupRef}>
                    <div className="wb-popup-content">
                        <div style={{position: "relative"}}>
                            <span onClick={togglePopup} className="wb-close-x">&#10005;</span>
                        </div>
                        {response === null && <>
                            <h2>{t("freeCode")}</h2>
                            <p style={{fontSize: "13px"}}>{t("freeCode.txt")}</p>
                            <div className='wb-mb-3' style={{fontSize: "13px"}}>
                                <div className='wb-grid-container wb-mb-1'>
                                    <label className='wb-grid-item-6 wb-label' htmlFor="name">{t("book.form.name")}</label>
                                    <input 
                                        className='wb-grid-item-6 wb-input'
                                        id="name"
                                        name="name"
                                        type="text"
                                        placeholder={t("book.form.name.hint")}
                                        disabled={isLoading}
                                        value={data.name.value}
                                        onChange={handleChanegData}
                                    />
                                </div>
                                {data.name.err && <p className='err-input' style={{width: '100%'}}>{data.name.err}</p>}
                                <div className='wb-grid-container'>
                                    <label className='wb-grid-item-6 wb-label' htmlFor="email">{t("book.form.email")}</label>
                                    <input 
                                        className='wb-grid-item-6 wb-input'
                                        id="email"
                                        name="email"
                                        type="text"
                                        placeholder={t("book.form.email.hint")}
                                        disabled={isLoading}
                                        value={data.email.value}
                                        onChange={handleChanegData}
                                    />
                                </div>
                                {data.email.err && <p className='err-input' style={{width: '100%'}}>{data.email.err}</p>}
                            </div>
                            
                            <div className='wb-grid-container wb-mb-2 wb-mt'>
                                <div className="wb-grid-item-6">
                                    <button 
                                        className='wb-btn-light-grey'
                                        style={{float: "left"}}
                                        onClick={togglePopup}
                                    >{t("book.form.btn.cancel")}</button>

                                    <button 
                                        className='wb-button-blue'
                                        style={{float: "right"}}
                                        onClick={handleSendFreeCode}
                                        disabled={isLoading}
                                    >{t("freeCode.btn")}</button>
                                </div>
                            </div>
                        </>}
                        {response && <>
                            <h2>{t(response.title)}</h2>
                            {response.reserved && 
                                <div className="wb-center-hw">
                                <img
                                    src={process.env.PUBLIC_URL + LetterGif}
                                    className="wb-letter-img"
                                    alt="Mail Icon"
                                    loading="lazy"
                                />
                                </div>
                            }
                            <p className='wb-mt-4' dangerouslySetInnerHTML={{__html: t(response.message)}} />
                            <button className='wb-button-blue wb-mt-2' style={{float: "right"}} onClick={togglePopup}>{t("btn.close")}</button>
                        </>}
                    </div>
                </div>
            )}
        </div>
    );
}

export default PopupFreeCode;